__turbopack_context__.v({
  "textButton": "TextButton-module__OyEcVa__textButton",
  "tone-weak": "TextButton-module__OyEcVa__tone-weak",
});
